export enum AdminSubscriptionOrderType {
  First = 'FIRST',
  Renewal = 'RENEWAL',
  Resubscribe = 'RESUBSCRIBE',
}
